export enum FlowTypes {
    Both = "both",
    AgeAdaptation = "ageAdaptation",
    Email = "email",
    Friends = "friends",
    Calisthenics = "calisthenics",
}
